import React from 'react';
import { FaCloud, FaCode, FaMobileAlt, FaPlug } from 'react-icons/fa';

const capabilities = [
  { icon: FaMobileAlt, title: 'Mobile development', description: 'Flutter and Dart applications for mobile and web experiences.' },
  { icon: FaCloud, title: 'Backend & cloud', description: 'Firebase services and Node.js support for connected applications.' },
  { icon: FaPlug, title: 'API integration', description: 'REST APIs and third-party services for practical product features.' },
  { icon: FaCode, title: 'Product development', description: 'Real-time, productivity, commerce, and utility applications.' },
];

export default function About() {
  return (
    <section className="px-4 py-16 sm:px-6 sm:py-24 lg:px-8" id="about">
      <div className="site-container">
        <div className="mb-8 max-w-2xl sm:mb-12">
          <p className="section-eyebrow">About me</p>
          <h2 className="mt-5 text-3xl font-extrabold tracking-tight text-white sm:text-5xl">Building useful mobile experiences with care.</h2>
        </div>
        <div className="grid gap-8 lg:grid-cols-[0.85fr_1.15fr] lg:gap-20">
          <div className="space-y-5 text-base leading-8 text-slate-400">
            <p>I am a detail-oriented Flutter developer focused on scalable, responsive applications for mobile and web platforms.</p>
            <p>My work combines Flutter and Dart with Firebase, REST APIs, third-party SDKs, cloud services, and backend tools such as Node.js and Firebase Functions.</p>
            <p>I care about clean architecture, effective state management, reusable components, responsive UI/UX, and turning complex requirements into practical digital experiences.</p>
          </div>
          <div className="grid gap-4 sm:grid-cols-2">
            {capabilities.map(({ icon: Icon, title, description }) => (
              <article key={title} className="surface-card group p-5 transition hover:-translate-y-1 hover:border-slate-500">
                <Icon className="text-cyan-300 transition group-hover:text-indigo-300" aria-hidden="true" />
                <h3 className="mt-5 text-base font-bold text-white">{title}</h3>
                <p className="mt-2 text-sm leading-6 text-slate-500">{description}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
